//-- Copyright (c) 2021 TMT Insights Group, LLC
import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from '@/redux/store';

export const selectLayoutSlice = (state: RootState) => state.layout;
export const selectSchemaDialog = createSelector(selectLayoutSlice, (layout) => layout.schema);
export const selectSchemaDialogOpen = createSelector(selectSchemaDialog, (schema) => schema.showDialog);
export const selectSchemaDialogErrors = createSelector(selectSchemaDialog, (schema) => schema.errors);

export const selectIsNavBarVisible = createSelector(selectLayoutSlice, ({ isNavBarVisible }) => isNavBarVisible);
